<div style="height: fit-content; max-height: 100%; width: 100%; position: relative" [hidden]="!showBox ? showBoxClicked() : false">
  <div [ngClass]="!useFixedPosition ? 'container-standard' : 'container-fixed'">
    <div class="form-div" *ngIf="showSearchField">
      <div class="search-bar">
        <input class="search-bar-input" #inputField placeholder="Search" (input)="onInputChange(inputField.value)" />
        <img src="https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/magnifier.svg" class="form-img" />
      </div>
    </div>
    <div class="line" *ngIf="showSelectAll"></div>
    <div class="hovering-item">
      <div class="item" (click)="onSelectAllClicked()" *ngIf="showSelectAll">
        <label class="disable-selection" [ngClass]="selectedSelectAll ? 'item-text-medium' : 'item-text'">
          <ng-container *ngIf="selectedSelectAll && checkboxType === 'square'">
            <img class="checkbox" [src]="iconService.Icon.checkbox_tick" />
          </ng-container>
          <ng-container *ngIf="!selectedSelectAll && checkboxType === 'square'">
            <img class="checkbox" [src]="iconService.Icon.checkbox_grey_empty" />
          </ng-container>
          <ng-container *ngIf="selectedSelectAll && checkboxType === 'circle'">
            <img class="checkbox" [src]="iconService.Icon.round_checkbox_grey_tick" />
          </ng-container>
          <ng-container *ngIf="!selectedSelectAll && checkboxType === 'circle'">
            <img class="checkbox" [src]="iconService.Icon.round_checkbox_grey_empty" />
          </ng-container>
          Select all
        </label>
      </div>
    </div>
    <div class="line" *ngIf="showSelectAll"></div>
    <div class="top-bottom-padding" [ngStyle]="{ 'max-height': maxHeight - 43 + 'px', 'padding-top': showSelectAll ? '0' : '8px' }">
      <div [hidden]="list.length < 1">
        <label class="header" [hidden]="isTyping" *ngIf="showHeaders">ALPHABETICAL</label>
        <div class="spacer" *ngIf="showHeaders"></div>
        <div class="items-container">
          <div *ngFor="let item of displayedList">
            <div class="hovering-item">
              <div [ngClass]="checkForDisabled(item.label) ? 'disabled-item' : 'item'" (click)="onItemClicked(item)">
                <label [ngStyle]="{ cursor: checkForDisabled(item.label) ? 'not-allowed' : 'pointer' }" class="disable-selection" [matTooltip]="item?.label" [matTooltipDisabled]="!withHoverEffect" [ngClass]="checkSelectedItems(item) ? 'item-text-bold' : 'item-text-left'">
                  {{ item.label }}
                  <ng-container *ngIf="checkSelectedItems(item) && checkboxType === 'square' && !isItemDisabled(item.label)">
                    <img class="checkbox" [src]="iconService.Icon.checkbox_tick" />
                  </ng-container>
                  <ng-container *ngIf="!checkSelectedItems(item) && checkboxType === 'square' && !isItemDisabled(item.label)">
                    <img class="checkbox" [src]="iconService.Icon.checkbox_grey_empty" />
                  </ng-container>
                  <ng-container *ngIf="(!checkSelectedItems(item) && checkboxType === 'square' && isItemDisabled(item.label)) || (checkSelectedItems(item) && checkboxType === 'square' && isItemDisabled(item.label))">
                    <img class="checkbox" [src]="iconService.Icon.checkbox_disabled" />
                  </ng-container>
                  <ng-container *ngIf="checkSelectedItems(item) && checkboxType === 'circle' && !isItemDisabled(item.label)">
                    <img class="checkbox" [src]="iconService.Icon.round_checkbox_grey_tick" />
                  </ng-container>
                  <ng-container *ngIf="!checkSelectedItems(item) && checkboxType === 'circle' && !isItemDisabled(item.label)">
                    <img class="checkbox" [src]="iconService.Icon.round_checkbox_grey_empty" />
                  </ng-container>
                  <ng-container *ngIf="(!checkSelectedItems(item) && checkboxType === 'circle' && isItemDisabled(item.label)) || (checkSelectedItems(item) && checkboxType === 'circle' && isItemDisabled(item.label))">
                    <img class="checkbox" [src]="iconService.Icon.round_checkbox_grey_disabled" />
                  </ng-container>
                </label>
              </div>
            </div>
          </div>
          <div class="no-result-text" *ngIf="displayedList.length === 0">No results</div>
        </div>
      </div>
    </div>
  </div>
</div>
